import * as actionTypes from "./types";
import * as authService from "./../../auth";
// import { router } from "../router/action";
import { settings } from "../settings/actions";

export const guestToken = ({ loginData }) => async (dispatch) => {
  dispatch({
    type: actionTypes.AUTH_LOADING_REQUEST,
    payload: { loading: true },
  });

  try {
    const data = await authService.fetchGuestToken({ loginData });

    if (data.success === true) {
      data.result.JwtToken
        ? localStorage.setItem("guest-token", data.result.JwtToken)
        : "";
      data.result.JwtToken
        ? localStorage.setItem(
          "CompanyName",
          data.result?.TokenMetadata?.CompanyName
        )
        : "";

      await dispatch(settings.set({
        tenantId: data.result?.TokenMetadata?.TenantId,
        tenantName: data.result?.TokenMetadata?.CompanyName
      }))
      await dispatch({
        type: actionTypes.AUTH_LOGIN_SUCCESS,
        payload: data.JwtToken,
      });
      // console.log('DBaaSSubscription', data.result?.TokenMetadata?.TenantMetaData?.DBaaSSubscription)
      // await dispatch(router.setSubscription({
      //   subscription: data.result?.TokenMetadata?.TenantMetaData?.DBaaSSubscription
      // }))
      return Promise.resolve(data);

    } else {
      await dispatch({
        type: actionTypes.AUTH_FAILED_REQUEST,
        payload: data,
      });
      localStorage.removeItem("guest-token");
      localStorage.removeItem("CompanyName");
      return Promise.reject(data); // Reject with the error data
    }
  } catch (e) {
    return Promise.reject(e); // Reject with the caught error
  }
};

export const generatePin =
  ({ loginData }) =>
    async (dispatch) => {
      dispatch({
        type: actionTypes.AUTH_LOADING_REQUEST,
        payload: { loading: true },
      });
      try {
        const data = await authService.generateLoginPin({ loginData });
        // console.log('generate pin data', data)
        if (data.success === true) {
          dispatch({
            type: actionTypes.AUTH_LOGIN_SUCCESS,
            payload: data.result.JwtToken,
          });
          // localStorage.setItem('access-token', data.result.JwtToken);
          return Promise.resolve(data); // Resolve with the JWT token
        } else {
          dispatch({
            type: actionTypes.AUTH_FAILED_REQUEST,
            payload: data,
          });
          return Promise.reject(data); // Reject with the error data
        }
      } catch (e) {
        return Promise.reject(e); // Reject with the caught error
      }
    };

export const requestOtp =
  ({ loginData }) =>
    async (dispatch) => {
      dispatch({
        type: actionTypes.AUTH_LOADING_REQUEST,
        payload: { loading: true },
      });
      try {
        const data = await authService.requestOtp({ loginData });

        if (data.success === true) {
          dispatch({
            type: actionTypes.AUTH_LOGIN_SUCCESS,
            payload: data.result.JwtToken,
          });
          localStorage.setItem('access-token', data.result.JwtToken);
          return Promise.resolve(data.result.JwtToken); // Resolve with the JWT token
        } else {
          dispatch({
            type: actionTypes.AUTH_FAILED_REQUEST,
            payload: data,
          });
          localStorage.removeItem("access-token");
          return Promise.reject(data); // Reject with the error data
        }
      } catch (e) {
        dispatch({
          type: actionTypes.AUTH_FAILED_REQUEST,
          payload: data,
        });
        localStorage.removeItem("access-token");
        return Promise.reject(e); // Reject with the caught error
      }
    };

export const login = ({ loginData }) => async (dispatch) => {
  dispatch({
    type: actionTypes.AUTH_LOADING_REQUEST,
    payload: { loading: true },
  });

  try {
    const data = await authService.login({ loginData });
    if (data?.success === true) {
      dispatch({
        type: actionTypes.AUTH_LOGIN_SUCCESS,
        payload: data.result.JwtToken,
      });
      localStorage.setItem('access-token', data.result.JwtToken);
      //console.log('login data.result', data.result)
      // await dispatch(router.setAccountTypes({
      //   accountTypes: data.result?.TokenMetadata?.AccountMetaData?.UserAccountTypes,
      // }))
      return Promise.resolve(data.result.JwtToken); // Resolve with the JWT token
    } else {
      await dispatch({
        type: actionTypes.AUTH_FAILED_REQUEST,
        payload: data,
      });
      dispatch({
        type: actionTypes.AUTH_FAILED_REQUEST,
        payload: data,
      });
      localStorage.removeItem("access-token");
      return Promise.reject(data); // Reject with the error data
    }
  } catch (error) {
    dispatch({
      type: actionTypes.AUTH_FAILED_REQUEST,
      payload: error,
    });
    dispatch({
      type: actionTypes.AUTH_FAILED_REQUEST,
      payload: data,
    });
    localStorage.removeItem("access-token");
    return Promise.reject(error); // Reject with the caught error
  }
};

export const loginWithPin = ({ loginData }) => async (dispatch) => {
  await dispatch({
    type: actionTypes.AUTH_LOADING_REQUEST,
    payload: { loading: true },
  });

  try {
    const data = await authService.loginWithPin({ loginData });
    if (data?.success === true) {
      await dispatch({
        type: actionTypes.AUTH_LOGIN_SUCCESS,
        payload: data.result.JwtToken,
      });
      localStorage.setItem('access-token', data.result.JwtToken);
      console.log('setAccountTypes data', data)
      // await dispatch(router.setAccountTypes({
      //   accountTypes: data?.result?.TokenMetadata?.AccountMetaData?.UserAccountTypes,
      // }))
      return Promise.resolve(data.result.JwtToken); // Resolve with the JWT token
    } else {
      await dispatch({
        type: actionTypes.AUTH_FAILED_REQUEST,
        payload: data,
      });
      dispatch({
        type: actionTypes.AUTH_FAILED_REQUEST,
        payload: data,
      });
      localStorage.removeItem("access-token");
      return Promise.reject(data); // Reject with the error data
    }
  } catch (error) {
    await dispatch({
      type: actionTypes.AUTH_FAILED_REQUEST,
      payload: error,
    });
    localStorage.removeItem("access-token");
    return Promise.reject(error); // Reject with the caught error
  }
};

export const forgotPassword =
  ({ loginData }) =>
    async (dispatch) => {
      dispatch({
        type: actionTypes.AUTH_LOADING_REQUEST,
        payload: { loading: true },
      });
      const data = await authService.forgotPassword({ loginData });

      if (data.success === true) {
        dispatch({
          type: actionTypes.AUTH_LOGIN_SUCCESS,
          payload: data.result.JwtToken,
        });
        localStorage.setItem('access-token', data.result.JwtToken)

      } else {
        dispatch({
          type: actionTypes.AUTH_FAILED_REQUEST,
          payload: data,
        });
      }
    };

export const resetPassword =
  ({ loginData }) =>
    async (dispatch) => {
      dispatch({
        type: actionTypes.AUTH_LOADING_REQUEST,
        payload: { loading: true },
      });
      const data = await authService.resetPassword({ loginData });

      if (data.success === true) {
        dispatch({
          type: actionTypes.AUTH_LOGIN_SUCCESS,
          payload: data.result.JwtToken,
        });
        localStorage.setItem('access-token', data.result.JwtToken)

      } else {
        dispatch({
          type: actionTypes.AUTH_FAILED_REQUEST,
          payload: data,
        });
      }
    };

export const logout = () => async (dispatch) => {
  authService.logout();
  dispatch({
    type: actionTypes.AUTH_LOGOUT_SUCCESS,
  });
};
